import { Context } from 'Context/Context';
import FormErrorBanner from 'Components/Element/FormErrorBanner'
import React, { useContext } from 'react'

// Profile header text: name/firm, a status pill and one line explaining it.
const STATUS = {
  0: { label: 'Profile incomplete', tone: 'brass', text: 'Complete your profile so we can verify your account.' },
  1: { label: 'Verified', tone: 'green', text: 'You can request to view cases.' },
  2: { label: 'Under review', tone: 'brass', text: "We're reviewing your profile. We'll let you know once it's done." },
  3: { label: 'Verified', tone: 'green', text: 'Your latest profile changes are under review.' },
  4: { label: 'Changes not approved', tone: 'red', text: 'We could not approve your profile changes. Review the comments and resubmit.' },
  5: { label: 'Not approved', tone: 'red', text: 'We could not approve your profile. Review the comments and resubmit.' },
};
const TONE = {
  green: 'text-success bg-success/[.08] border-success/[.3]',
  brass: 'text-brass bg-brass/[.08] border-brass/[.3]',
  red: 'text-danger bg-danger/[.07] border-danger/[.3]',
};

function AccountStatusInfo({isUserVerified, updatesSent, title}) {
  const {userDetails} = useContext(Context);
  const assistant = !!userDetails?.isUserAssistant;
  const status = assistant ? null : STATUS[isUserVerified];
  const text = assistant
    ? (userDetails?.profilePic
        ? 'Send a request to a verified attorney so you can start seeing case details.'
        : 'Complete your profile so you can start seeing case details.')
    : status?.text;

  return (
    <div className='w-full min-w-0 flex flex-col gap-2 font-plexsans'>
        {title &&
          <div className='font-spectral font-normal text-[22px] lg:text-[24px] leading-[1.25] text-navy [overflow-wrap:anywhere]'>{title}</div>}
        {status &&
          <span className={`self-start inline-flex items-center gap-1.5 font-semibold text-[11.5px] leading-none border rounded-[20px] py-1.5 px-2.5 ${TONE[status.tone]}`}>
            <span className='w-1.5 h-1.5 rounded-full bg-current' />{status.label}
          </span>}
        {text && <p className='m-0 text-[13.5px] leading-[1.55] text-navy/[.65]'>{text}</p>}
        {(isUserVerified === 4 || isUserVerified === 5) && updatesSent?.deniedMessage &&
          <div className='mt-1'>
            <FormErrorBanner><b>Review message:</b> {updatesSent?.deniedMessage}</FormErrorBanner>
          </div>}
    </div>
  )
}

export default AccountStatusInfo
